export default {
  app: {
    name: 'Zachary Seguin Music',
    version: '2.0.0',
    icon: 'https://music.zacharyseguin.ca/icon.svg'
  },
  developerToken: 'eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkI0RzVITjYyODcifQ.eyJpYXQiOjE2NzY4MzI1ODksImV4cCI6MTY5MjM4NDU4OSwiaXNzIjoiNDhVTTlUODcyMyJ9.vFuOlFtdsRjyGrKNvLAZctGerSTUniJ3X9bg0Y16VsDZdxuvEvNZjcfajo0dqXE3IkWh3f7dSetVOAJIzzLGHQ'
//  developerToken: 'eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkI0RzVITjYyODcifQ.eyJpYXQiOjE2NDM5NDU1NjksImV4cCI6MTY1OTQ5NzU2OSwiaXNzIjoiNDhVTTlUODcyMyJ9.h1oPLOJqsohSzBRZjn4qp41zyvtfEaIFr_PBHqff3bufijcjtBHDGu83Gg4SDDZ1vqkDw1sb_UA3kI7sOB5_JQ'
  // Optional:
  // sentry: 'sentryurlandtoken'
};
